/**
 * External dependencies
 */
export default class Marketing {
  constructor(cscom) {
    if (!(this instanceof Marketing)) {
      return new Marketing(cscom);
    }
    this.cscom = cscom;
  }

  sendLastMonthSummary() {
    return this.cscom.req.post(
      "/api/rest/talink/marketing/send-last-month-email"
    );
  }

  sendSubcribedEmails() {
    return this.cscom.req.post(
      "/api/rest/talink/marketing/send-subscribed-emails"
    );
  }
}
